<template>
  <div class="income-details">
    <b-card no-body class="p-3" v-loading="is_loading">
      <b-row>
        <b-col cols="12" md="6">
          <div class="card-table-simple">
            <b-table-simple bordered responsive>
              <b-thead>
                <b-th colspan="2" class="text-center">Details</b-th>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-th>Net Income</b-th>
                  <b-td>
                    <CurrencyInput v-model="formData.net_income" :disabled=true
                      :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th>NDI</b-th>
                  <b-td class="bg-warning">
                    <CurrencyInput v-model="formData.net_dispose_income" @blur="calculate(true)"
                      :disabled="isViewOnly"
                      :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th>Interest Rate</b-th>
                  <b-td class="bg-warning">
										<b-form-input v-model="formData.interest_rate" :disabled="isViewOnly"
											@blur="calculate(true)" @keydown="_gHlp.checkNonNumericInput"></b-form-input>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th>Instalment Eligible</b-th>
                  <b-td>
                    <CurrencyInput v-model="formData.installment_eligible" :disabled=true
                      :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th>CCRIS Commitment <br/>(After Settle)</b-th>
                  <b-td>
                    <CurrencyInput v-model="formData.final_installment" :disabled=true
                      :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th>Instalment Available</b-th>
                  <b-td>
                    <CurrencyInput v-model="formData.installment_available" :disabled=true
                      :options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-col>
        <b-col cols="12" md="6">
          <div class="card-table-simple">
            <b-table-simple bordered responsive>
              <b-thead>
                <b-th colspan="5" class="text-center">Loan Eligible</b-th>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(eligible, index) in formData.loanEligibleList" :key="index" :class="eligible.period === selected_period ? 'bg-warning' : ''">
                  <b-th>{{ eligible.period }}</b-th>
                  <b-td>{{ eligible.eligible_amount | moneyFormatter }}</b-td>
                  <b-td :class="_gConst.getColor(eligible.status)">{{ eligible.after_debt_conso | moneyFormatter }}</b-td>
                  <b-td :class="_gConst.getColor(eligible.status)">{{ eligible.status }}</b-td>
                  <b-td class="text-center">
                    <el-switch 
													:key="index"
													v-model="selected_period"
													:active-value="eligible.period"
													:inactive-value="null"
													@change="handleSelectedEligible(eligible)"
													active-color="#099A78"
													:disabled="eligible.status === 'FAIL' || isViewOnly"></el-switch>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import { Switch, Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';

export default {
	props: [
    'is-view-only'
  ],
  components: {
    CurrencyInput,
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
			selected_period: '',
			selectedEligible:{},
			formData:{
				loan_type_id:'',
				net_income:0,
				net_dispose_income:0,
				installment_eligible:0,
				ccris_commitment:0,
				installment_available:0,
				final_installment:0,
				loan_amount:0,
				loan_tenure:1,
				loan_tenure_period:'Years',
				loan_tenure_year:0,
				loanEligibleList:[]
			},
    }
  },
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
  computed: {
		...mapState(useCustomerStore, ['activeFormLoanEc']),
    is_loading(){
			return _gHlp.isLoading('fetch_loan_type') || _gHlp.isLoading('calc_loan_eligible') || _gHlp.isLoading('calc_loan_calculator') || _gHlp.isLoading('fetch_loan_ec')
		}
  },
  // created() {
	// 	this.initComponent();
	// },
  watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
				
					if(!_gHlp.isEmpty(this.formData.loanEligibleList)){
						let selected_period = _gHlp.getValue(newVal,'loan_eligible_period')
						this.selectedEligible = this.formData.loanEligibleList.find(itm => (this.formData.loan_type_id == itm.loan_type_id && selected_period == itm.period))
						if(!_gHlp.isEmpty(this.selectedEligible)){
							this.selected_period = cloneDeep(this.selectedEligible.period)
						}
					}
				}
			},
			immediate: true
		}
  },
  methods: {
		clearComponent(){
			this.selected_period = ''
			this.selectedEligible = {}
			this.formData = {
				loan_type_id:'',
				net_income:0,
				net_dispose_income:0,
				installment_eligible:0,
				ccris_commitment:0,
				installment_available:0,
				final_installment:0,
				loan_amount:0,
				loan_tenure:1,
				loan_tenure_period:'Years',
				loan_tenure_year:0,
				loanEligibleList:[]
			}
		},
	  viewLoanTable() {
      this.modals.view_loan_table = !this.modals.view_loan_table
    },
		calculate(with_save=false) {
			let params = {
				net_dispose_income: this.formData.net_dispose_income,
				interest_rate: this.formData.interest_rate,
				loan_eligible_period: this.formData.loan_eligible_period,
				loan_amount: this.formData.loan_amount,
				eligible_loan_limit: this.formData.eligible_loan_limit,
				loan_tenure: this.formData.loan_tenure,
				loan_tenure_period: this.formData.loan_tenure_period,
				loan_tenure_year: this.formData.loan_tenure_year,
				is_save: with_save,
			}	
			this.$emit('change',params);
		},
    handleSelectedEligible(selected) {
			if(!_gHlp.isEmpty(this.selected_period) && this.selected_period === selected.period){
				this.formData.loan_amount = selected.eligible_amount;
				this.formData.eligible_loan_limit = selected.after_debt_conso;
				this.formData.loan_eligible_period = selected.period;
				this.formData.loan_tenure = selected.period_number;
				this.formData.loan_tenure_period = selected.tenure_period;
				this.formData.loan_tenure_year = (this.formData.loan_eligible_period.includes('Years')) ? selected.period_number : (selected.period_number / 12).toFixed(2);
				
				let currPeriode = _gHlp.getValue(this.selectedEligible,'period');
				if(currPeriode != selected.period){
					this.calculate(true);
				}else{
					this.calculate(false);
				}
			}
    },
  }
}
</script>